export default __webpack_public_path__ + "static/media/5.ce75a546.jpg";